module.exports = __webpack_public_path__ + "img/20191218.46456161.png";